import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Modal, Input, H3, Text } from '@bigcommerce/big-design';

import { paymentTermDisable } from '../../../redux/actions/paymentTerms';

const DisablePaymentTermModal = ({ payload, showDisablePaymentTermModal, setShowDisablePaymentTermModal, paymentTerm, disablePaymentTerm }) => {
  const disable = () => {
    disablePaymentTerm(payload, paymentTerm.id);
    setShowDisablePaymentTermModal(false);
  }

  return(
    <>
      { paymentTerm &&
        <Modal
          actions={[
            {
              text: 'Cancel',
              variant: 'subtle',
              onClick: () => setShowDisablePaymentTermModal(false),
            },
            { text: 'Disable Payment Term', onClick: () => disable() },
          ]}
          closeOnClickOutside={true}
          closeOnEscKey={true}
          header="Disable Payment Term"
          isOpen={showDisablePaymentTermModal}
          onClose={() => setShowDisablePaymentTermModal(false)}
        >
          <H3>Disable {paymentTerm.term_name}</H3>
          <Text>
            Confirm that this payment term should be disabled. Suppliers using this payment term by default will no longer have a default payment term set.
          </Text>
        </Modal>
      }
    </>
  )
}

const mapStateToProps = state => ({ 
});

const mapDispatchToProps = (dispatch) => ({
  disablePaymentTerm: (payload, paymentTermId) => dispatch(paymentTermDisable(payload, paymentTermId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DisablePaymentTermModal);